import { dataExportStore, type TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { MultiSelect } from 'components/MultiSelect/MultiSelect'
import { translate } from 'i18n/i18n'
import type { TPoint } from 'stores/fieldAssetStore/helperTypes'
import { makeExternalVendorMultiSelectProps } from 'utils/makeExternalVendorMultiSelectProps'
import { sortByKey } from 'utils/sortByKey'

export const PointsSelect = ({
  options,
}: {
  options: Array<{ value: string; label: string; externalVendorNames?: TPoint['externalVendorNames'] }>
}) => {
  const state = dataExportStore.useSelector((s) => s)

  return (
    <div>
      <div css={{ fontSize: 17 }}>{translate.phrases.banyanApp('Devices')}</div>
      <div css={{ marginTop: 10, marginBottom: 10 }}>
        <MultiSelect
          selectedData={state.formState.points
            .map((lngLat) => ({
              value: lngLat,
              label: options.find((x) => x.value === lngLat)?.label,
              id: lngLat,
            }))
            .sort(sortByKey('label'))}
          onChange={(data) =>
            dataExportStore.actions.changePoints(
              data.map((x) => x.value) as TDataExportStoreState['formState']['points'],
            )
          }
          data={options}
          {...makeExternalVendorMultiSelectProps({ data: options })}
        />
      </div>
    </div>
  )
}
